import { render } from "./FormCreateEdit.vue?vue&type=template&id=719eb4ac&scoped=true"
import script from "./FormCreateEdit.vue?vue&type=script&lang=js"
export * from "./FormCreateEdit.vue?vue&type=script&lang=js"

import "./FormCreateEdit.vue?vue&type=style&index=0&id=719eb4ac&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-719eb4ac"

export default script